<template>
	<div class="bg-white px-3 goods_create"
		style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'khgl_khgl_khxx' }" style="position: absolute;top: 32px;left: 200px;"><el-button
				size="mini">回到客户列表</el-button></router-link>
		<el-button type="primary" size="mini" style="position: absolute;top: 32px;left: 340px;" @click="initData">一键清除</el-button>
		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 33%;">
					<el-form-item label="客户名称"><el-input v-model="lists.name" style="width: 94%;"
							size="mini"></el-input></el-form-item>
					<el-form-item label="身份证"><el-input v-model="lists.sfz" style="width: 94%;"
							size="mini"></el-input></el-form-item>
					<el-form-item label="联系电话"><el-input v-model="lists.phone" style="width: 94%;"
							size="mini"></el-input></el-form-item>
					<div class="d-flex">
						<div style="width: 50%;">
							<el-form-item label="分类费类型">
								<el-select v-model="lists.flflx_id" placeholder="请选择" size="mini" style="width: 94%;">
									<el-option v-for="item in flflxlist" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div style="width: 50%;">
							<el-form-item label="结算运费">
								<el-select v-model="lists.jsyf" placeholder="请选择" size="mini" style="width: 94%;">
									<el-option v-for="item in jsyflist" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class="d-flex">
						<div style="width: 50%;">
							<el-form-item label="运费支付人">
								<el-select v-model="lists.yfzfr" placeholder="请选择" size="mini" style="width: 94%;">
									<el-option v-for="item in yfzfrlist" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div style="width: 50%;">
							<el-form-item label="提货码方式">
								<el-select v-model="lists.ztmfs" placeholder="请选择" size="mini" style="width: 94%;">
									<el-option v-for="item in ztmfslist" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class="d-flex">
						<div style="width: 50%;">
							<el-form-item label="校验密钥">
								<div class="d-flex">
									<div style="color: #009dff;" @click="fzwb(lists.jymy)">{{ lists.jymy }}</div>
								</div>
							</el-form-item>
						</div>

						<div style="width: 50%;">
							<el-form-item label="提货人">
								<el-select v-model="lists.thr" placeholder="请选择" size="mini" style="width: 94%;">
									<el-option v-for="item in thrlist" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</div>

					</div>
					<el-form-item label="提货类型">
						<el-select v-model="lists.hyfs" placeholder="请选择" size="mini" style="width: 94%;">
							<el-option v-for="item in thlxlist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="提货码">
						<div class="d-flex">
							<div style="color: #009dff;" @click="fzthm(lists.thm)">{{ lists.thm }}</div>
						</div>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="客户简称">
						<el-input v-model="lists.j_name" style="width: 70%;margin-right: 6px;" size="mini" placeholder="数字"
							@input="handleSelect"></el-input>
						<span :style="{ color: jczt != '可使用' ? '#fa0000' : '#0057fa' }" v-if="jczt != ''">{{ jczt
							}}</span>
					</el-form-item>
					<div class="d-flex">
						<div style="width: 50%;">
							<el-form-item label="计费单位">
								<el-select v-model="lists.jfdw_id" filterable placeholder="请选择" size="mini"
									style="width: 94%;">
									<el-option v-for="item in jfdwlist" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div style="width: 50%;">
							<el-form-item label="计费周期">
								<el-select v-model="lists.jfzq" filterable placeholder="请选择" size="mini"
									style="width: 94%;">
									<el-option v-for="item in jfzqlist" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<el-form-item label="信息地址"><el-input v-model="lists.city" style="width: 94%;"
							size="mini"></el-input></el-form-item>
					<el-form-item label="线路信息">
						<el-select v-model="lists.xl_id" placeholder="请选择" size="mini" style="width: 94%;">
							<el-option v-for="item in jcxllist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="最低库存量"><el-input-number v-model="lists.zdkcl" :min="0"
							size="mini"></el-input-number></el-form-item>
					<el-form-item label="通知收费"><el-input v-model="lists.sf_phone" style="width: 90%;" type="textarea"
							:rows="2" size="mini"></el-input></el-form-item>
					<el-form-item label="班车单位" v-if="lists.hyfs == 2">
						<el-radio-group v-model="lists.hyfs_bcdw">
							<el-radio :label="0">吨</el-radio>
							<el-radio :label="1">件</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="班车单价" v-if="lists.hyfs == 2">
						<el-input-number v-model="lists.hyfs_dj" :precision="2" :min="0" size="mini"
							v-if="lists.hyfs_bcdw == 1"></el-input-number>
						<div v-else>80/吨</div>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="备注"><el-input v-model="lists.desc" style="width: 90%;"
							size="mini"></el-input></el-form-item>
					<div class="d-flex">
						<div style="width: 60%;">
							<el-form-item label="客户类型">
								<el-select v-model="lists.lb_id" placeholder="请选择" size="mini" style="width: 94%;">
									<el-option v-for="item in khlblist" :key="item.id" :label="item.mc"
										:value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div style="width: 40%;">
							<el-form-item label="是否转租客">
								<el-switch v-model="lists.sfzzk" active-color="#13ce66"
									inactive-color="#ff4949"></el-switch>
							</el-form-item>
						</div>
					</div>
					<el-form-item label="档口地址"><el-input v-model="lists.dkcity" style="width: 94%;"
							size="mini"></el-input></el-form-item>
					<div class="d-flex">
						<div style="width: 40%;">
							<el-form-item label="收取押金">
								<el-switch v-model="lists.syj" active-color="#13ce66"
									inactive-color="#ff4949"></el-switch>
							</el-form-item>
						</div>
						<div style="width: 60%;">
							<el-form-item label="押金金额" v-if="lists.syj == true">
								<el-input-number v-model="lists.yjje" :min="0" size="mini"></el-input-number>
							</el-form-item>
						</div>
					</div>
					<el-form-item label="运费单价"><el-input-number v-model="lists.yfdj" :precision="2" :min="0"
							size="mini"></el-input-number></el-form-item>
					<el-form-item label="通知到货"><el-input v-model="lists.dh_phone" style="width: 90%;" type="textarea"
							:rows="2" size="mini"></el-input></el-form-item>
					<el-form-item label="仓库">
						<el-select v-model="lists.ck_id" filterable style="width: 90%;" size="mini">
							<el-option v-for="item in cklist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>

				</div>
			</div>
		</el-form>
		<el-button type="primary" style="position: fixed;bottom: 50px;right: 50px;" @click="submit">提交</el-button>
	</div>
</template>

<script>
import {
	mapState
} from 'vuex'; // 引入 全局 公共数据
const initList = {
	name: '',
	phone: '',
	flflx_id: 1,
	jsyf: 0,
	j_name: '',
	sf_phone: '',
	jfdw_id: '',
	jfzq: '',
	desc: '',
	dh_phone: '',
	lb_id: 1,
	sfzzk: 0,
	city: '',
	hyfs: '',
	ztmfs: '',
	syj: 0,
	xl_id: '',
	thr: '',
	yfzfr: '',
	zdkcl: 0,
	yfdj: 0,
	yjje: 0,
	dkcity: '',
	sfz: '',
	ck_id: 1
}
export default {
	inject: ['app', 'layout'],
	data() {
		return {
			cklist: [],
			lists:initList,
			yhs: [],
			jsyflist: [{
				value: 0,
				label: '当次结算运费'
			},
			{
				value: 1,
				label: '月结运费'
			}
			],
			flflxlist: [],
			jfdwlist: [],
			khlblist: [],
			jcxllist: [],
			thlxlist: [],
			jczt: '',
			thrlist: [{
				value: 0,
				label: 'A-货主'
			},
			{
				value: 1,
				label: 'B-xx'
			}
			],
			yfzfrlist: [{
				value: 0,
				label: 'A-货主'
			},
			{
				value: 1,
				label: 'B-xx'
			}
			],
			ztmfslist: [{
				value: 0,
				label: '一天一码'
			},
			{
				value: 1,
				label: '一票一码'
			}
			],
			jfzqlist: [{
				value: 1,
				label: '1天'
			}, {
				value: 3,
				label: '3天'
			}, {
				value: 7,
				label: '7天'
			}, {
				value: 10,
				label: '10天'
			}],
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	// 生命周期
	created() {
		this.lists = this.$route.params.data;
		if (this.lists.syj == 0) {
			this.lists.syj = false
		} else {
			this.lists.syj = true
		}
		if (this.lists.sfzzk == 0) {
			this.lists.sfzzk = false
		} else {
			this.lists.sfzzk = true
		}
		console.log(this.lists)
		this.axios.get('/admin/managers/list', {
			token: true
		}).then(res => {
			this.yhs = res.data.data;
		});
		this.axios.get('/admin/flflx/1', {
			token: true
		}).then(res => {
			this.flflxlist = res.data.data.list;
		});
		this.axios.get('/admin/jfdw/1', {
			token: true
		}).then(res => {
			this.jfdwlist = res.data.data.list;
		});
		this.axios.get('/admin/khlbkhxx', {
			token: true
		}).then(res => {
			this.khlblist = res.data.data;
		});
		this.axios.get('/admin/hyxl/1', {
			token: true
		}).then(res => {
			this.jcxllist = res.data.data.list;
		});
		this.axios.get('/admin/thlx/1', {
			token: true
		}).then(res => {
			this.thlxlist = res.data.data.list;
		});
		this.axios.get('/admin/cangkus', { token: true }).then(res => {
			this.cklist = res.data.data;
		});
	},
	methods: {
		initData(){
			this.lists=initList
		},
		onClick(e, editor) { },
		handleChange(value) { },
		chooseImage() {
			this.app.chooseImage(res => {
				this.lists.cptp = res[0].url;
			}, 1);
		},
		fzwb(e) {
			navigator.clipboard.writeText(e).then(() => {
				this.$message({
					type: 'success',
					message: '复制成功'
				});
			})
		},
		fzthm(e) {
			navigator.clipboard.writeText(e).then(() => {
				this.$message({
					type: 'success',
					message: '复制成功'
				});
			})
		},
		handleSelect(item) {
			const numbers = item.match(/\d+/g).join('')
			this.lists.j_name=numbers
			this.axios.post('/admin/jcjc', { data: item }, {
				token: true
			})
				.then(res => {
					this.jczt = res.data.data
				})
		},
		//提交
		submit() {
			if (this.jczt == '已存在') {
				this.$message({
					type: 'warning',
					message: '用户简称请勿重复使用'
				});
			} else {
				this.layout.showLoading();
				if (!this.lists.id) {
					this.lists.cjr = this.user.id
					this.lists.czr = this.user.id
					this.lists.jfpz_czr = this.user.id
				} else {
					this.lists.czr = this.user.id
				}
				if (this.lists.syj == false) {
					this.lists.syj = 0
				} else {
					this.lists.syj = 1
				}
				if (this.lists.sfzzk == false) {
					this.lists.sfzzk = 0
				} else {
					this.lists.sfzzk = 1
				}
				let url = this.lists.id ? '/admin/khxx/' + this.lists.id : '/admin/khxx';
				this.axios
					.post(url, this.lists, {
						token: true
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: this.id ? '修改成功' : '添加成功'
						});
						this.$router.push({
							name: 'khgl_khgl_khxx'
						});
						this.layout.hideLoading();
					})
					.catch(err => {
						this.layout.hideLoading();
					});
			}

		}
	}
};
</script>

<style>
.goods_create .el-form-item {
	margin-bottom: 15px;
}

.el-form-item__label {
	width: 84px !important;
}

.pt-a {
	padding-top: 20px;
}
</style>